import { X } from 'lucide-react';

import {
  COLOR_SCALE,
  FONT_WEIGHTS,
  PADDING_Y,
  RADIUS_SCALE,
  SIZE_SCALE,
  PADDING_X,
} from '@/components/design-system/tokens';

interface MobileMenuHeaderProps {
  onClose: () => void;
  t: (namespace: string, key: string, fallback: string) => string;
}

export const MobileMenuHeader = ({ onClose, t }: MobileMenuHeaderProps) => (
  <div
    className={`flex justify-between items-center ${PADDING_X['6']} ${PADDING_Y['4']} ${COLOR_SCALE.surface} shadow-sm`}
  >
    <span
      className={`text-xl ${FONT_WEIGHTS.bold} bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent`}
    >
      MEDIPATHS
    </span>
    <button
      onClick={onClose}
      className={`${SIZE_SCALE.w10} ${SIZE_SCALE['10']} flex items-center justify-center ${RADIUS_SCALE.full} hover:${COLOR_SCALE['surface-subtle']} transition-colors`}
      aria-label={t('aria', 'close_menu', 'Close menu')}
    >
      <X className={`${SIZE_SCALE.w5} ${SIZE_SCALE['5']} ${COLOR_SCALE['foreground-muted']}`} />
    </button>
  </div>
);
